import { render } from "./FleetManagerDashboard.vue?vue&type=template&id=1a22f0ca&scoped=true"
import script from "./FleetManagerDashboard.vue?vue&type=script&lang=js"
export * from "./FleetManagerDashboard.vue?vue&type=script&lang=js"

import "./FleetManagerDashboard.vue?vue&type=style&index=0&id=1a22f0ca&lang=css"
import "./FleetManagerDashboard.vue?vue&type=style&index=1&id=1a22f0ca&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a22f0ca"]])

export default __exports__